import { Type } from 'class-transformer';

/**
 * Model to capture Risk Profile Score.
 */
export class RiskProfileScoreType {
    riskClass: String;
    riskScore: number;
    applicableRules = new Array<String>();
    @Type(() => RiskProfileScore)
    values: RiskProfileScore;

}

export class RiskProfileScore {
    riskClass: String;
    riskScore: number;
    applicableRules = new Array<String>();
}



// WEBPACK FOOTER //
// ./src/app/shared/models/risk-profile-score.model.ts